'use strict';

import { DateTime } from 'luxon';

import { getEvents } from '../../utils/api';
import { loadWidget } from '../utils/load-widget';
import simpleTimezone from '../../utils/simple-timezone';

const SPECIAL_MESSAGING_CATEGORY = 30;

loadWidget('performance-list', {
    props: ['prodSeasonId', 'performanceId'],
    data: function() {
        return {
            ViewModel: {
                Loading: true,
                Performances: [],
                ProdSeasonID: parseInt(this.prodSeasonId, 10),
                PerformanceID: parseInt(this.performanceId, 10),
            },
        };
    },
    beforeMount() {
        getEvents()
            .then(events => {
                const now = DateTime.now();

                events = events.filter(event => {

                    return (
                        (
                            event.prod_season_no === this.ViewModel.ProdSeasonID ||
                            event.perf_no === this.ViewModel.PerformanceID
                        ) &&
                        DateTime.fromISO(event.perf_date) > now
                    );
                });

                this.ViewModel.Performances = events.map(ev => {
                    const perf = DateTime.fromISO(ev.perf_date);

                    const specialMessaging = ev.keywords.filter(keyword => {
                        return keyword.category_no === SPECIAL_MESSAGING_CATEGORY;
                    }).map(keyword => {
                        return keyword.keyword;
                    });

                    let Booking = false;
                    let Stream = false;

                    const offSaleDate = DateTime.fromISO(ev.off_sale_date);
                    const onSaleDate = DateTime.fromISO(ev.on_sale_date);

                    if (offSaleDate > now && onSaleDate < now && !ev.hide_buy_tickets) {
                        Booking = {
                            Link: ev.custom_booking && ev.custom_booking.url ? ev.custom_booking.url : ev.perf_book_url,
                            Text: ev.custom_booking && ev.custom_booking.status ? ev.custom_booking.status : 'Buy',
                        };
                    }

                    if (ev.stream.perf_no === ev.perf_no) {
                        Stream = {
                            Link: ev.stream.link,
                            Title: ev.stream.title,
                            ProductionId: ev.stream.productionId,
                        };
                    }

                    let hasMinutes = false;

                    if (perf.toFormat("m") > 0) {
                        hasMinutes = true;
                    }

                    let eventTime = hasMinutes
                        ? perf.toFormat("h:mma")
                        : perf.toFormat("ha");

                    return {
                        Date: perf.toFormat("ccc LLL d"),
                        Time: `${eventTime} ${simpleTimezone(perf)}`,
                        ProdSeasonNo: ev.prod_season_no,
                        PerfNo: ev.perf_no,
                        Booking,
                        Stream,
                        SpecialMessaging: specialMessaging,
                    };
                });
            })
            .finally(() => {
                this.ViewModel.Loading = false;
                if (this.ViewModel.Performances.length > 0) {
                    const navigationButton = document.getElementById('concert-nav-purchase-btn');
                    navigationButton.removeAttribute('hidden');
                }
            });
    }
});
